import React, { Component } from 'react';
import { Form, Input } from '@roo/roo';
import { Col, Row } from '@roo/roo/Grid';
import {
    BaseFeeInfoTypeEnum,
    CommissionInfoTypeEnum,
    IEffectHostingInfoSignFormProps,
    IEffectHostingInfoSignFormRate,
    IEffectHostingInfoSignFormValue,
} from '../api';
import EffectHostingSignArray from './EffectHostingSignArray';

const { Field } = Form;

interface Istate {
    formVal: IEffectHostingInfoSignFormValue | undefined;
}

export default class EffectHostingSignForm extends Component<
    IEffectHostingInfoSignFormProps,
    Istate
> {
    constructor(props) {
        super(props);
        this.state = {
            formVal: undefined,
        };
    }

    // 一位小数的数字格式校验
    numReg = /^[0-9]+([.]\d{1})?$/;

    componentDidMount(): void {
        const { info } = this.props;
        if (info.baseFeeInfo.typeLabel !== '') {
            // 这种情况下info是更新过的
            const obj = {
                baseFeeInfo: {
                    typeValue: info.baseFeeInfo.typeValue,
                    earningsThreshold: info.baseFeeInfo.earningsThreshold,
                    baseFee: info.baseFeeInfo.baseFee,
                    deposit: info.baseFeeInfo.deposit,
                    typeLabel: info.baseFeeInfo.typeLabel,
                },
                commissionInfo: {
                    typeValue: info.commissionInfo.typeValue,
                    typeLabel: info.commissionInfo.typeLabel,
                    intervalList:
                        info.commissionInfo.typeValue !== CommissionInfoTypeEnum.No
                            ? [
                                  {
                                      intervalBegin: info.commissionInfo.intervalBegin,
                                      intervalEnd: info.commissionInfo.intervalEnd,
                                      rate: info.commissionInfo.rate,
                                  },
                              ]
                            : [],
                },
            };
            this.setState({ formVal: obj });
        }
    }

    intervalListValidator = (
        rule: any,
        value: IEffectHostingInfoSignFormRate[],
        baseFeeINfoType: BaseFeeInfoTypeEnum,
        earningsThreshold: string,
        commissionInfoType: CommissionInfoTypeEnum,
    ) => {
        // 先判断数组里面所有项都要有值
        for (let i = 0; i < value.length; i++) {
            const { intervalBegin, intervalEnd, rate } = value[i];
            if (intervalBegin === '' || intervalEnd === '' || rate === '') {
                return new Error('请检查未填字段');
            }
            if (
                !this.numReg.test(intervalBegin) ||
                !this.numReg.test(intervalEnd) ||
                !this.numReg.test(rate)
            ) {
                return new Error('仅限数字，到小数点后1位');
            }
        }
        //数组至少为1个 第一阶梯单独做判断，修改范围不能超过设置的值
        const { rate, intervalBegin } = value[0];
        const beginNum = parseFloat(intervalBegin) || 0;
        const rateNum = parseFloat(rate) || 0;
        const { info } = this.props;
        const rateNumMax = parseFloat(info.commissionInfo.rate) || 0;

        const errMsg = (name: string, val: number) =>
            `第一阶梯的${name}不能超过创建商品时候的值${val}`;
        if (rateNum > rateNumMax) {
            return new Error(errMsg('比例', rateNumMax));
        }

        if (baseFeeINfoType === BaseFeeInfoTypeEnum.PayDay) {
            // 按天场景
            // 第一阶段的左值X≥商家日实收门槛
            const earningsThresholdNum = parseFloat(earningsThreshold) || 0;
            if (beginNum < earningsThresholdNum) {
                return new Error('第一阶段的左值X≥商家日实收门槛');
            }
        }

        if (
            baseFeeINfoType === BaseFeeInfoTypeEnum.FixedPrice &&
            commissionInfoType === CommissionInfoTypeEnum.Increment
        ) {
            // 一口价服务费+增量抽佣
            // 第一阶段的左值X≥10
            if (beginNum < 10) {
                return new Error('第一阶段的左值X≥10');
            }
        }

        // 剩下的情况
        for (let i = 0; i < value.length; i++) {
            const { intervalBegin, intervalEnd } = value[i];
            const begin = parseFloat(intervalBegin) || 0;
            const end = parseFloat(intervalEnd) || 0;
            if (begin >= end) {
                return new Error('下限 <= 商家实收 < 上限');
            }
        }
        return true;
    };

    earningsThresholdValidator = (rule: any, value: string, baseFee: string) => {
        if (!this.numReg.test(value)) {
            return new Error('仅限数字，到小数点后1位');
        }
        const num = parseFloat(value) || 0;
        const baseFeeNum = parseFloat(baseFee) || 0;
        if (num < baseFeeNum) {
            return new Error('商家日实收门槛要大于等于服务费');
        }
        return true;
    };

    baseFeeValidator = (rule: any, value: string, earningsThreshold: string) => {
        // 一口价基础服务费不会修改，这里的改动都是按天扣费场景

        if (!this.numReg.test(value)) {
            return new Error('仅限数字，到小数点后1位');
        }
        const num = parseFloat(value) || 0;
        const earningsThresholdNum = parseFloat(earningsThreshold) || 0;
        if (num < 25 || num > 100) {
            return new Error('服务费输入值25≤X≤100');
        }
        if (num > earningsThresholdNum) {
            return new Error('商家日实收门槛要大于等于服务费');
        }
        return true;
    };

    render() {
        const { info, effectFormRef, coopMode } = this.props;
        const { formVal } = this.state;
        return (
            <div style={{ marginLeft: '20px' }}>
                {formVal && (
                    <Form
                        ref={effectFormRef}
                        layout="inline"
                        value={formVal}
                        // cols={{
                        //     label: { span: 4 },
                        //     field: { span: 8 },
                        // }}
                        onChange={() => {
                            console.log('form-change', effectFormRef.current);
                            effectFormRef.current.validateForm();
                        }}
                    >
                        {({ values }) => (
                            <Row>
                                <Col span={4}>
                                    <Row>
                                        <Field
                                            label="基础服务费收费方式"
                                            name="baseFeeInfo.typeLabel"
                                            disabled
                                        />
                                    </Row>
                                    <Row>
                                        <Field
                                            label="抽佣方式&emsp;&emsp;&emsp;&emsp;&emsp;"
                                            name="commissionInfo.typeLabel"
                                            disabled
                                        />
                                    </Row>
                                    <Row>
                                        {info.baseFeeInfo.typeValue ===
                                            BaseFeeInfoTypeEnum.PayDay && (
                                            <Field
                                                label="定金&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;"
                                                name="baseFeeInfo.deposit"
                                                disabled
                                                as={
                                                    <Input
                                                        suffix={
                                                            <span style={{ fontSize: '14px' }}>
                                                                元
                                                            </span>
                                                        }
                                                    />
                                                }
                                            />
                                        )}
                                    </Row>
                                </Col>
                                <Col span={8}>
                                    <Row>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {info.baseFeeInfo.typeValue ===
                                            BaseFeeInfoTypeEnum.FixedPrice ? (
                                                <>
                                                    <Field
                                                        label="服务费价格"
                                                        name="baseFeeInfo.baseFee"
                                                        disabled
                                                        as={
                                                            <Input
                                                                suffix={
                                                                    <span
                                                                        style={{ fontSize: '14px' }}
                                                                    >
                                                                        元
                                                                    </span>
                                                                }
                                                            />
                                                        }
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    <span
                                                        style={{
                                                            display: 'inline-block',
                                                            marginRight: '20px',
                                                        }}
                                                    >
                                                        服务费价格
                                                    </span>
                                                    商家日实收＞
                                                    <Field
                                                        name="baseFeeInfo.earningsThreshold"
                                                        rule={{
                                                            validator: (rule, value) =>
                                                                this.earningsThresholdValidator(
                                                                    rule,
                                                                    value,
                                                                    values.baseFeeInfo.baseFee,
                                                                ),
                                                        }}
                                                    />
                                                    元后，收取服务费
                                                    <Field
                                                        name="baseFeeInfo.baseFee"
                                                        rule={{
                                                            validator: (rule, value) =>
                                                                this.baseFeeValidator(
                                                                    rule,
                                                                    value,
                                                                    values.baseFeeInfo
                                                                        .earningsThreshold,
                                                                ),
                                                        }}
                                                    />
                                                    元/天
                                                </>
                                            )}
                                        </div>
                                    </Row>
                                    <Row>
                                        {info.commissionInfo.typeValue !==
                                            CommissionInfoTypeEnum.No && (
                                            <Field
                                                label="抽佣比例"
                                                name="commissionInfo.intervalList"
                                                rule={{
                                                    validator: (rule, value) =>
                                                        this.intervalListValidator(
                                                            rule,
                                                            value,
                                                            values.baseFeeInfo.typeValue,
                                                            values.baseFeeInfo.earningsThreshold,
                                                            values.commissionInfo.typeValue,
                                                        ),
                                                }}
                                            >
                                                {({ value, handleChange }) => (
                                                    <EffectHostingSignArray
                                                        value={value}
                                                        handleChange={handleChange}
                                                        commissionType={
                                                            info.commissionInfo.typeValue
                                                        }
                                                        baseFeeType={info.baseFeeInfo.typeValue}
                                                        coopMode={coopMode}
                                                    />
                                                )}
                                            </Field>
                                        )}
                                    </Row>
                                </Col>
                            </Row>
                        )}
                    </Form>
                )}
            </div>
        );
    }
}
